import React from 'react';
import { getBezierPath } from 'reactflow';

const CustomConnectionLine = ({
  fromX,
  fromY,
  fromPosition,
  toX,
  toY,
  toPosition,
  connectionStatus,
}) => {
  const [edgePath] = getBezierPath({
    sourceX: fromX,
    sourceY: fromY,
    sourcePosition: fromPosition,
    targetX: toX,
    targetY: toY,
    targetPosition: toPosition,
  });

  const stroke =
    connectionStatus === 'valid'
      ? '#22c55e'
      : connectionStatus === 'invalid'
        ? '#9ca3af'
        : '#6b7280';

  return (
    <g>
      <path
        fill="none"
        stroke={stroke}
        strokeWidth={connectionStatus === 'valid' ? 3 : 2}
        strokeDasharray="6 4"
        d={edgePath}
      />
    </g>
  );
};

export default CustomConnectionLine;
